import React from 'react'
import { IoExitOutline } from 'react-icons/io5'
import { useNavigate } from 'react-router-dom'

function ProfitDefinition(props) {
    const { userDataFromStorage, coloredTheme } = props;

    let navigate = useNavigate()

    return (
        <div className={userDataFromStorage.user_role === 'admin' ? 'xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[2rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[15%]  xl:mt-[9%] mt-[20%] bg-blue-50  overflow-hidden' : 'xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[2rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[10%]  xl:mt-[5%] mt-[20%] bg-blue-50 overflow-hidden'}>
            <p className='text-gray-800 text-[1.8rem] tracking-wider'>Profitability Reports</p>
            <p className='text-gray-600 text-[1rem] tracking-wider mt-6'>Includes Closed and Defaulted loans</p>
            <p className='text-gray-600 text-[1rem] tracking-wider leading-[2rem]'>
                For Defaulted Loans to be included the last transaction date must be within the "Loan Closed After" and "Loan Closed Before" search parameters<br />

                Claims reported are those made within the "Loan Closed After" and "Loan Closed Before" search parameters<br />

                Profit against Agent and Managers in MYR = Total Cash In - Total Cash Out - Agent Stamp Commission - Claims<br />

                Profit against Loan Products in MYR = Total Cash In - Total Cash Out - Agent Stamp Commission<br />

                Profit % = Profit * 100 / Total Cash out<br />

                Manager profit numbers are a cumulation of all their staff loans plus loans where they were the agent<br />

                Admin profit numbers on "By Manager" are the cumulation of loans where the Managers were the loan's Agent
            </p>
            <div className='flex justify-start items-center mt-12'>
                <button onClick={()=>navigate('/reports/profit_report')} style={{ backgroundColor: coloredTheme }} className='flex justify-center items-center  rounded space-x-2 px-[1rem] py-[0.5rem] mt-6 text-white '>
                    <IoExitOutline />
                    <p>Exit</p>
                </button>
            </div>
        </div>
    )
}

export default ProfitDefinition